import React, { Component } from 'react'
import { BrowserRouter as AppRouter, Route, Switch, Redirect } from 'react-router-dom'
import NotFound from './NotFound'

// Routes
import { DefaultLayout, titleTemplate, defaultRoute, routes } from '../routes'
import helpers from "./layouts/helpers";
import Login from "../components/Login";
import Register from "../components/Register";
import Claim from "../components/Claim";
import VerifyLogin from "../components/VerifyLogin";
import ClaimGUID from "../components/ClaimGUID";
import CreatePassword from "../components/CreatePassword";

// ---
// Main route component

class AnonymousRouter extends Component {
  constructor(props) {
    super(props);

  }

  setTitle(title) {
      document.title = titleTemplate.replace('%s', title)
  }


  render() {
    return (
      <AppRouter basename={process.env.REACT_APP_BASENAME}>
        <Switch>
            <Route
                path={"/verifyLogin/:token/:country"}
                exact={true}
                render={props => {
                    return <VerifyLogin {...props}/>
                }}
                key={"/verifyLogin"}
            />
           <Route
              path={"/:company"}
              exact={true}
              render={props => {
                return <Login {...props}/>
              }}
              key={"/"}
            />
           <Route
              path={"/register/:guid/:country/:department?"}
              exact={true}
              render={props => {
                return <Register {...props}/>
              }}
              key={"/register/:guid/:country/:department?"}
            />
           <Route
              path={"/claim/:guid"}
              exact={true}
              render={props => {
                return <ClaimGUID {...props}/>
              }}
              key={"/claim/:guid"}
            />
           <Route
              path={"/cp/:guid/:country"}
              exact={true}
              render={props => {
                return <CreatePassword {...props}/>
              }}
              key={"/cp/:guid"}
            />

          <Route path="*" component={Login} />
        </Switch>
      </AppRouter>
    )
  }
}

export default AnonymousRouter
